import { FILTER_TYPES } from 'components/FilterPod';

const filters = [
  {
    title: 'شناسه کاربر',
    label: 'شناسه کاربر',
    keyName: 'userId',
    id: 2147,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },
  {
    title: 'تلفن همراه',
    label: 'تلفن همراه',
    keyName: 'phoneNumber',
    id: 2151,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },

  {
    title: 'شناسه',
    label: 'شناسه',
    keyName: 'id',
    id: 2148,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },
];

export default filters;
